// ─────────────────────────────────────────────────────────────────────────────
// forceMetrics.js — MXF (Max Force), MFA (angle at max force).
// Pure functions. Inputs MUST already be zero-corrected.
// ─────────────────────────────────────────────────────────────────────────────

import { catchAngle, finishAngle, DEFAULT_CATCH_THRESHOLD_N, DEFAULT_FINISH_THRESHOLD_N } from './catchFinish';

/**
 * Max Force (MXF) and Max Force Angle (MFA) across the drive phase.
 * Drive phase = samples where angle is between CA and FA (inclusive).
 *
 * If multiple samples share MXF, the FIRST occurrence is returned (deterministic).
 */
export function maxForceMetrics(forceN, angleDeg, opts = {}) {
  if (!Array.isArray(forceN) || !Array.isArray(angleDeg) || forceN.length !== angleDeg.length || forceN.length === 0) {
    return { MXF: null, MFA: null };
  }
  const ca = catchAngle(forceN, angleDeg, opts.catchThreshold ?? DEFAULT_CATCH_THRESHOLD_N);
  const fa = finishAngle(forceN, angleDeg, opts.finishThreshold ?? DEFAULT_FINISH_THRESHOLD_N);
  if (ca == null || fa == null) return { MXF: null, MFA: null };

  let mxf = -Infinity;
  let mfa = null;
  for (let i = 0; i < forceN.length; i += 1) {
    const a = angleDeg[i];
    if (a < ca || a > fa) continue;
    if (forceN[i] > mxf) {
      mxf = forceN[i];
      mfa = a;
    }
  }
  if (mxf === -Infinity) return { MXF: null, MFA: null };
  return { MXF: mxf, MFA: mfa };
}
